<template>
  <div ref="container" class="filter-lists-container" :class="{ horizontal: isHorizontal }">
    <div v-if="images.length > 0">
      <template
        v-for="(imgItem, imgIndex) in images"
      >
        <screenshot-image-item
          v-show="isAMatch(imgItem)"
          :number ="imgIndex + 1"
          :findingIndex="getFindingIndexByImageID(imgItem.findingID)"
          :class="{ 'selected-print': imgItem.status === '1', 'focus': (!hideFocusItem && imgIndex === 0) } "
          :item="imgItem"
          :findingSelectItems="findingSelectItems"
          :landmarkSelectItems="landmarkSelectItems"
          :landmarkText="imgItem.landmarkID === 0 ? null : getLandmarkTextByID(imgItem.landmarkID)"
          @imgStatusChange="$emit('imgStatusChange', imgIndex)"
          @findingChange="findingChange(imgItem.id, $event)"
          @landmarkChange="landmarkChange(imgItem.id, $event)"
          @deleteImg="$emit('deleteImg', $event)"
        ></screenshot-image-item>
      </template>
    </div>

    <div v-else class="no-images">No Images</div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ScreenshotImageItem from '@/components/screenshots/ScreenshotImageItem.vue'

  export default {
    name: 'FilterImagesList',

    props: {
      images: {
        type: Array,
        required: true
      },

      active: {
        type: [String, Number],
        required: false
      },

      filterItems: {
        type: Array,
        required: false
      },

      landmarks: {
        type: Array,
        required: true
      },

      horizontal: {
        type: Boolean,
        required: false,
        default: false
      },

      hideFocusItem: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    components: {
      ScreenshotImageItem
    },

    data() {
      return {
      }
    },

    computed: {
      ...mapGetters('examinations', [
        'getExaminationData'
      ]),
      isHorizontal () {
        return this.horizontal
      },

      activeTab() {
        return this.active
      },

      landmarkSelectItems() {
        let items = this.landmarks.map(elm => {
          return {
            value: elm.id,
            text: elm.landmark
          }
        })

        items.unshift({
          value: 0,
          text: "Choose"
        })

        return items
      },

      findingSelectItems() {
        let items = this.filterItems.map((elm, index) => {
          return {
            value: elm.id,
            text: `Finding ${index + 1}`
          }
        })

        items.unshift({
          value: 0,
          text: "Choose"
        })

        return items
      }
    },
    watch : {
      images: function (val) {
        this.assignFixWidthToContainer();
      }
    },
    methods: {
      isAMatch(img) {
        const active = this.activeTab

        switch (active) {
          case 'all':
            return true

          case 'landmark':
            return img.landmarkID && (img.landmarkID !== 0)

          case 'print':
            return img.status && (img.status === "1")

          default:
            {
              const activeID = this.filterItems[active] && this.filterItems[active].id
              return activeID === img.findingID
            }
        }
      },

      getLandmarkTextByID (id) {
        const item = this.landmarks.find(elm => elm.id === Number(id))
        if (item) {
          return item.landmark
        } else {
          return ''
        }
      },

      findingChange(id, event) {
        this.$emit('findingChange', {
          id,
          newValue: event
        })
      },

      landmarkChange(id, event) {
        console.log(id, event)
        this.$emit('landmarkChange', {
          id,
          newValue: event
        })
      },
      getFindingIndexByImageID(findingID) {
        let findingIndex = null
        this.getExaminationData.findings.map((finding, index) => {
          if (finding.id === findingID) {
            findingIndex = index + 1
          }
        })
        return findingIndex
      },
      assignFixWidthToContainer () {
        if(this.horizontal == true) {
          const imageWidth = 190;        
          this.$refs.container.style.width = this.images.length * imageWidth + 'px';
        }
      }
    },
    mounted() {
      this.assignFixWidthToContainer();
    }
  }
</script>

<style lang="scss">
  // @import '@/styles/pages/page_examinationDetail.scss';
</style>